import logoImage from "../../assets/images/Icons/logo.png";

const Logo = () => {
  return <img className="Logo" src={logoImage} alt=""></img>;
};

export default Logo;
